import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import style from "../components/contact.module.scss"

function createMarkup(tekst) {
  return { __html: tekst }
}

export default function Contact({ teamCol, contactCol, row }) {
  const data = useStaticQuery(
    graphql`
      query MyTeamAndContact {
        allTekstJson {
          edges {
            node {
              team {
                curatoren {
                  carien
                  miriam
                }
                advies
                bestuur
                productie
                raad
              }
              contact {
                mail
                extra
                mogelijk
                samenwerking
                website {
                  ontwerp
                  realisatie
                }
              }
            }
          }
        }
        mondriaan: file(relativePath: { eq: "logo_mondriaan.jpg" }) {
          childImageSharp {
            fluid(quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        amersfoort: file(relativePath: { eq: "logo_amersfoort.jpg" }) {
          childImageSharp {
            fluid(quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `
  )
  const teamgegevens = data.allTekstJson.edges[0].node.team
  const contactgegevens = data.allTekstJson.edges[0].node.contact
  const cols = ["1/8", "6/13", "11/18", "16/23"]

  return (
    <div className={style.wrapper} id="contact" style={{ gridRow: row }}>
      <div className={style.tekstWrapper}>
        <div
          className={style.tekst}
          style={{ gridColumn: cols[teamCol - 1], gridRow: "0" }}
        >
          <h2>Team</h2>
          <h3>Curatoren</h3>
          <p>{teamgegevens.curatoren.carien}</p>
          <br />
          <p>{teamgegevens.curatoren.miriam}</p>
          <h3>Productie en participatie</h3>
          <p>{teamgegevens.productie}</p>
          <h3>Advies</h3>
          <p>{teamgegevens.advies}</p>
          {/* <h3>Bestuur</h3>
          <ul>
            {teamgegevens.bestuur.map((lid, index) => (
              <li key={index}>{lid}</li>
            ))}
          </ul> */}
          <h3>Raad van Toezicht</h3>
          <ul>
            {teamgegevens.raad.map((lid, index) => (
              <li key={index}>{lid}</li>
            ))}
          </ul>
        </div>
        <div
          className={style.tekst}
          style={{ gridColumn: cols[contactCol - 1] }}
        >
          <h2>Contact</h2>
          <h3>E-mail</h3>
          <p>{contactgegevens.mail}</p>

          <h3>WEEF werkt samen met:</h3>
          <ul>
            {contactgegevens.samenwerking.map((partner, index) => (
              <li key={index}>{partner}</li>
            ))}
          </ul>
          <h3>WEEF wordt mogelijk gemaakt door:</h3>
          <ul>
            {contactgegevens.mogelijk.map((lid, index) => (
              <li key={index}>{lid}</li>
            ))}
          </ul>
          <h3>Website</h3>
          <ul>
            <li key="ontwerp">{`ontwerp: ${contactgegevens.website.ontwerp}`}</li>
            <li key="ontwikkeling">
              code:{" "}
              <a
                href="https://bartkipping.nl"
                target="_blank"
                rel="noreferrer"
                style={{ color: "black", outline: "none" }}
              >{`${contactgegevens.website.realisatie}`}</a>
            </li>
          </ul>
          <br />
          <p dangerouslySetInnerHTML={createMarkup(contactgegevens.extra)}></p>
        </div>
      </div>
      <div className={style.logos}>
        <Img
          fluid={data.amersfoort.childImageSharp.fluid}
          fadeIn={false}
          durationFadeIn={1000}
          style={{ marginBottom: "1.25rem" }}
        ></Img>
        <Img
          fluid={data.mondriaan.childImageSharp.fluid}
          fadeIn={false}
          durationFadeIn={1000}
        ></Img>
      </div>
    </div>
  )
}
